import React from 'react'

import type { SubstitutionDragController } from './useSubstitutionDrag'

type SubstitutionDragOverlayProps = Pick<SubstitutionDragController, 'dragState' | 'dragPosition' | 'dragGhostRef' | 'returnGhost'>

function ghostPlayerNameClass(label: string, isPlayerLabel: boolean) {
	if (!isPlayerLabel) {
		return ''
	}
	const lengthClass = label.length >= 14 ? ' very-long-name' : label.length >= 9 ? ' long-name' : ''
	return ` substitution-ghost-player-name${lengthClass}`
}

export default function SubstitutionDragOverlay(props: SubstitutionDragOverlayProps) {
	const { dragState, dragPosition, dragGhostRef, returnGhost } = props

	return (
		<>
			{dragState ? (
				<div
					ref={dragGhostRef}
					className="substitution-drag-ghost-positioner"
					style={{
						width: dragState.width,
						height: dragState.height,
						transform: `translate3d(${dragPosition.current.left}px, ${dragPosition.current.top}px, 0)`,
						'--substitution-ghost-lift': `${-dragState.liftY}px`,
					} as React.CSSProperties}
				>
					<div className="substitution-drag-ghost">
						<span className={`substitution-ghost-role cell-position-${dragState.positionName}${ghostPlayerNameClass(dragState.label, dragState.isPlayerLabel)}`}>
							{dragState.label}
						</span>
					</div>
				</div>
			) : null}
			{returnGhost ? (
				<div
					className="substitution-return-ghost"
					style={{
						left: returnGhost.left,
						top: returnGhost.top,
						width: returnGhost.width,
						height: returnGhost.height,
						'--substitution-return-x': `${returnGhost.deltaX}px`,
						'--substitution-return-y': `${returnGhost.deltaY}px`,
					} as React.CSSProperties}
				>
					<span className={`substitution-ghost-role cell-position-${returnGhost.positionName}${ghostPlayerNameClass(returnGhost.label, returnGhost.isPlayerLabel)}`}>
						{returnGhost.label}
					</span>
				</div>
			) : null}
		</>
	)
}
